export enum TradeVersion {
    LATEST = 'LATEST',
    ORIGINAL = 'ORIGINAL'
}
